<template>
  <div class="form-field">
    <label class="field-label">اسم الموقع</label>
    <InputText v-model="local.site_title" class="w-100" placeholder="مصطفى حسني" />
  </div>
  <div class="form-field">
    <label class="field-label">الشعار <span class="optional">اختياري</span></label>
    <img v-if="currentLogoLink && !logoFile" :src="currentLogoLink" alt="" class="current-image-preview mb-2" />
    <div :class="['upload-zone', { 'upload-zone--has-file': logoFile }]">
      <div class="upload-zone__icon"><i :class="`pi ${logoFile ? 'pi-check' : 'pi-cloud-upload'}`"></i></div>
      <p class="upload-zone__label">{{ logoFile ? logoFile.name : 'اضغط لاختيار صورة' }}</p>
      <input type="file" accept="image/*" @change="onLogoChange" />
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, watch } from 'vue';
import InputText from 'primevue/inputtext';

const props = defineProps({
  modelValue: { type: Object, default: () => ({}) },
  currentLogoLink: { type: String, default: null },
});
const emit = defineEmits(['update:modelValue', 'update:logoFile']);

const local = reactive({ site_title: props.modelValue.site_title ?? '' });
const logoFile = ref(null);

watch(local, () => emit('update:modelValue', { ...props.modelValue, ...local }), { deep: true });

function onLogoChange(e) {
  logoFile.value = e.target.files[0] || null;
  emit('update:logoFile', logoFile.value);
}
</script>
